export default {"src":"/_next/static/media/history-item-menu-icon-red.56da6eb6.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};